const log_details = {
    page_title: 'جزئیات گزارش ممیزی',
    back_to_logs: 'بازگشت به گزارش‌های ممیزی',
    back_to: 'بازگشت به {{name}}',
    success: 'موفق',
    failed: 'ناموفق',
    event_key: 'کلید رویداد',
    application: 'برنامه',
    ip_address: 'آدرس IP',
    user: 'کاربر',
    log_id: 'شناسه گزارش',
    time: 'زمان',
    user_agent: 'عامل کاربر',
    tab_details: 'جزئیات',
    raw_data: 'داده خام',
};
export default Object.freeze(log_details);
